<template>
	<div class="claim-filter">
		<h2>Search Claims History</h2>

		<div class="input-wrapper">
			<div class="form-group select-input">
				<label for="claim-type" class="sr-only">Select an option</label>
				<select id="claim-type" v-model="type">
					<option value="" selected disabled>Select an option</option>
					<option value="controlNumber">Control Number</option>
					<option value="PONumber">PO Number</option>
					<option value="LMCInvoiceNumber">LMC Invoice Number</option>
					<option value="LmcInvoiceDate">Invoice Date</option>
					<option value="VendorInvoiceNumber">Vendor Invoice Number</option>
					<option value="VendorName">Vendor Name</option>
				</select>
			</div>

			<md-field class="input-group search-input-group">

				<md-input type="search"
						  id="search-input"
						  name="searchtext"
						  class="form-control search-input"
						  v-model.lazy="searchText"
						  aria-label="Search News..."
						  v-on:keyup.enter="addApiUrls()"></md-input>
				<label for="search-input" class="form-control-placeholder">Search Term</label>
				<span class="input-group-btn search-submit">
					<input class="icon-search submit-input" type="submit" value="search" v-on:click="addApiUrls()" />
				</span>
				<span class="clear-filter" v-on:click="clearSearch()" tabindex="0">clear all</span>
			</md-field>


		</div>
		
	</div>

</template>

<script>
	export default {
		props: ['searchtext', 'inputplaceholder', 'selectedoption'],
			data: function () {
				return {
					type: '',
					searchText: ''
				}
			},
		watch: {
			searchtext(val, oldVal) {
				this.query = val;
			}
		},
		mounted() {
			document.getElementsByClassName('js-claim-history-export')[0].classList.remove('hide');
			},
		methods: {
			addApiUrls() {
				let query = {
					[this.type]: this.searchText
				}
				
				let formattedQuery = Object.assign({}, query)

				this.$emit('setclaimfilter', formattedQuery);
			},
			clearSearch() {
				
				this.type = '';
				this.searchText = '';
				
				this.addApiUrls();
			}
		}
	}

</script>